export default "__VITE_ASSET__DKYHA_6t__"